import { UsStates } from "state/RootSchema";
import { z } from "zod";

export type ClubCodes =
    | "001"
    | "004"
    | "005"
    | "006"
    | "007"
    | "014"
    | "018"
    | "020"
    | "023"
    | "036"
    | "047"
    | "049"
    | "057"
    | "065"
    | "069"
    | "071"
    | "080"
    | "084"
    | "104"
    | "111"
    | "113"
    | "130"
    | "137"
    | "160"
    | "176"
    | "177"
    | "188"
    | "195"
    | "212"
    | "215"
    | "219"
    | "222"
    | "238"
    | "240"
    | "241"
    | "252"
    | "258"
    | "260"
    | "270"
    | "601";

export const DirectTermPlanCodesSchema = z.enum(["DMAT18", "DMMT18", "DMNY18", "DMWA18"]);
export type DirectTermPlanCodes = z.infer<typeof DirectTermPlanCodesSchema>;

/** Note that these are not the accurate underlying plan codes but instead are placeholder values which are handled by FAST
 * and then translated to the appropriate plan codes.
 */
export const LoyaltyTravelAccidentPlanCodesSchema = z.enum(["MLTA", "ACLTA"]);
export type LoyaltyTravelAccidentPlanCodes = z.infer<typeof LoyaltyTravelAccidentPlanCodesSchema>;

export function getDirectTermPlanCode(state: UsStates): DirectTermPlanCodes {
    switch (state) {
        case "WA":
        case "MA":
            return "DMWA18";
        case "NY":
            return "DMNY18";
        case "FL":
        case "ID":
        case "KS":
        case "ME":
        case "MN":
        case "NC":
        case "NH":
        case "OH":
        case "VT":
        default:
            return "DMAT18";
    }
}

export function getLoyaltyTravelAccidentPlanCode(clubCode: ClubCodes): LoyaltyTravelAccidentPlanCodes {
    if (clubCode === "004") {
        return "ACLTA";
    } else {
        return "MLTA";
    }
}
